import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'

export class EventsRepository extends BaseRepository<null> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'events', token, cache)
    }

    async getEventTypes() {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/events/types/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getEventSources() {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/events/sources/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
